forceNextPop